import { render, staticRenderFns } from "./createOrEditProfile.vue?vue&type=template&id=7f804c2a&scoped=true"
import script from "./createOrEditProfile.vue?vue&type=script&lang=js"
export * from "./createOrEditProfile.vue?vue&type=script&lang=js"
import style0 from "./createOrEditProfile.vue?vue&type=style&index=0&id=7f804c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f804c2a",
  null
  
)

export default component.exports